import {
  checkVersionParam,
  getPreprodVersion,
  loadPrerelease,
} from '@/lib/preprod/loader';

if (!checkVersionParam()) {
  const version = getPreprodVersion();

  if (version) {
    loadPrerelease(version);
  } else {
    import('./app');
  }
}
